import { api } from '@/api';

export const resetPasswordMutation = () => ({
  mutationFn: async (email: string) => {
    await api.SendForgotPasswordToken(null, { email });
    return;
  },
});
